"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var jsts = __importStar(require("jsts"));
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryType_1 = require("./GeometryType");
var __1 = require("..");
var Validators_1 = __importDefault(require("../shared/Validators"));
var radianFactor = Math.PI / 180.0;
var degreeFactor = 180.0 / Math.PI;
var Point = /** @class */ (function (_super) {
    __extends(Point, _super);
    function Point(x, y) {
        var _this = _super.call(this) || this;
        _this.x = 0;
        _this.y = 0;
        !lodash_1.default.isUndefined(x) && (_this.x = x);
        !lodash_1.default.isUndefined(y) && (_this.y = y);
        return _this;
    }
    Object.defineProperty(Point.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.Point;
        },
        enumerable: true,
        configurable: true
    });
    Point.prototype.coordinatesFlat = function () {
        return [{ x: this.x, y: this.y }];
    };
    Point.prototype.coordinates = function () {
        return [this.x, this.y];
    };
    Point.prototype.forEachCoordinates = function (callback) {
        callback(this);
    };
    Point.prototype.geocentricLine = function (point, segmentCount) {
        if (segmentCount === void 0) { segmentCount = 300; }
        var ddEnvelope = new __1.Envelope(-180, -90, 180, 90);
        var targetPoint = new Point(point.x, point.y);
        if (__1.Envelope.disjoined(ddEnvelope, targetPoint.envelope()) || __1.Envelope.disjoined(ddEnvelope, this.envelope())) {
            return undefined;
        }
        var _a = [this.x, this.y, targetPoint.x, targetPoint.y].map(function (n) { return n * radianFactor; }), lng1 = _a[0], lat1 = _a[1], lng2 = _a[2], lat2 = _a[3];
        var _b = [[lng1, lat1], [lng2, lat2]].map(function (c) { return Math.cos(c[0]) * Math.cos(c[1]); }), x1 = _b[0], x2 = _b[1];
        var _c = [[lng1, lat1], [lng2, lat2]].map(function (c) { return Math.sin(c[0]) * Math.cos(c[1]); }), y1 = _c[0], y2 = _c[1];
        var _d = [lat1, lat2].map(function (lat) { return Math.sin(lat); }), z1 = _d[0], z2 = _d[1];
        var alpha = Math.acos((x1 * x2) + (y1 * y2) + (z1 * z2));
        if (alpha === 0) {
            return new __1.MultiLineString([__1.LineString.fromPoints(this, point)]);
        }
        var _e = [[x1, x2], [y1, y2], [z1, z2]]
            .map(function (n) { return (n[1] - (n[0] * Math.cos(alpha))) / Math.sin(alpha); }), x3 = _e[0], y3 = _e[1], z3 = _e[2];
        var result = new __1.MultiLineString();
        var line1 = new __1.LineString();
        var line2 = new __1.LineString();
        line1._coordinates.push({ x: this.x, y: this.y });
        var disconnected = false;
        var _f = [0, 0], newX = _f[0], newY = _f[1];
        var _loop_1 = function (i) {
            var currentAlpha = i * alpha / (segmentCount + 1);
            var _a = [[x1, x3], [y1, y3], [z1, z3]]
                .map(function (n) { return n[0] * Math.cos(currentAlpha) + n[1] * Math.sin(currentAlpha); }), xbm = _a[0], ybm = _a[1], zbm = _a[2];
            newX = Math.atan(ybm / xbm) * degreeFactor;
            if (xbm < 0 && ybm < 0) {
                newX -= 180;
            }
            else if (ybm > 0 && xbm < 0) {
                newX += 180;
            }
            newY = Math.asin(zbm) * degreeFactor;
            if (i > 2 && !disconnected) {
                var lastDistance = Point._distance(line1._coordinates[i - 3], line1._coordinates[i - 2]);
                var currDistance = Point._distance({ x: newX, y: newY }, line1._coordinates[i - 2]);
                if (currDistance > lastDistance * 6) {
                    disconnected = true;
                }
            }
            if (!disconnected) {
                line1._coordinates.push({ x: newX, y: newY });
            }
            else {
                line2._coordinates.push({ x: newX, y: newY });
            }
        };
        for (var i = 1; i <= segmentCount; i++) {
            _loop_1(i);
        }
        if (!disconnected) {
            line1._coordinates.push({ x: point.x, y: point.y });
            result.children.push(line1);
        }
        else {
            line2._coordinates.push({ x: point.x, y: point.y });
            result.children.push(line1);
            result.children.push(line2);
        }
        return result;
    };
    Point.prototype._ts = function () {
        var coordinate = new jsts.geom.Coordinate(this.x, this.y);
        return Geometry_1.default._factory.createPoint(coordinate);
    };
    Point.fromNumbers = function () {
        var coordinates = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            coordinates[_i] = arguments[_i];
        }
        Validators_1.default.validateCoordinateNumbers(coordinates, 2);
        return new Point(coordinates[0], coordinates[1]);
    };
    Point.prototype._clone = function (convert) {
        var tmp = { x: this.x, y: this.y };
        if (convert !== undefined) {
            tmp = convert(tmp);
        }
        return new Point(tmp.x, tmp.y);
    };
    Point._from = function (point) {
        return new Point(point.getX(), point.getY());
    };
    Point._distance = function (p1, p2) {
        var distance = Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
        return distance;
    };
    return Point;
}(Geometry_1.default));
exports.default = Point;
